import React, { useCallback } from 'react';
import { useModal } from 'mui-modal-provider';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  AppointmentRequestButton as AppointmentRequestButtonView,
} from './appointment-request-button';
import { AppointmentRegistrationModal } from '../appointment-registration-modal';
import { AskLoginModal } from '../../../common/ask-login-modal';
import { appointmentSettings, IAppointmentSettingsProps } from '../../../common/appointment-settings';
import { useGoBack } from '../../../../hooks/use-go-back';
import { InternalLinks } from '../../../../constants';
import { setRedirectUrl } from '../../../../utils/redirect/redirect';

const AppointmentRequestButtonComponent = ({
  isLoggedIn, appointments, isLoading, isError, updateAppointments, appointmentUrl,
}: IAppointmentSettingsProps): JSX.Element => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPreviousLocationState } = useGoBack();

  const onNavigate = (url: string): void => {
    navigate(url, { state: hasPreviousLocationState });
  };

  const handleNavigateToRegistration = useCallback(() => {
    setRedirectUrl(location.pathname);
    navigate(InternalLinks.registration);
  }, [navigate, location.pathname]);

  const handleNavigateToLogin = useCallback(() => {
    setRedirectUrl(location.pathname);
    navigate(InternalLinks.login);
  }, [navigate, location.pathname]);

  const handleButtonClick = () => {
    if (isLoggedIn && appointmentUrl) return;

    if (isLoggedIn) {
      showModal(AppointmentRegistrationModal, { updateAppointments: updateAppointments!, onNavigate });
    } else {

      showModal(AskLoginModal, {
        description: 'appointment.loginRegister.modal.description',
        onNavigateToRegistration: handleNavigateToRegistration,
        onNavigateToLogin: handleNavigateToLogin,
      });
    }
  };

  return (
    <AppointmentRequestButtonView
      isLoggedIn={isLoggedIn}
      appointmentUrl={ isLoggedIn ? appointmentUrl : undefined }
      isLoading={isLoading}
      isError={isError}
      appointments={appointments}
      onClick={handleButtonClick}
    />
  );
};

export const AppointmentRequestButton = appointmentSettings(AppointmentRequestButtonComponent);
